// color_palettes/index.js
import basicPalettes from './basic.js';
import cakoPalettes from './cako.js';
import colourscafePalettes from './colourscafe.js';
import d3Palettes from './d3.js';
import dalePalettes from './dale.js';
import ducciPalettes from './ducci.js';
import duotonePalettes from './duotone.js';
import expositoPalettes from './exposito.js';
import flourishPalettes from './flourish.js';
import golidmiscPalettes from './golidmisc.js';
import hildaPalettes from './hilda.js';
import iivonenPalettes from './iivonen.js';
import judsonPalettes from './judson.js';
import jungPalettes from './jung.js';
import kovecsesPalettes from './kovecses.js';
import mayoPalettes from './mayo.js';
import metbrewerPalettes from './metbrewer.js';
import ranganathPalettes from './ranganath.js';
import rohlfsPalettes from './rohlfs.js';
import roygbivsPalettes from './roygbivs.js';
import spatialPalettes from './spatial.js';
import systemPalettes from './system.js';
import tsuchimochiPalettes from './tsuchimochi.js';
import tundraPalettes from './tundra.js';
import orbifoldPalettes from './orbifold.js';
import lospecPalettes from './lospec.js';
import momaPalettes from './moma.js';
import feathersPalettes from './feathers.js';

// Export all palettes as a single array
export default [
  ...basicPalettes,
  ...cakoPalettes,
  ...colourscafePalettes,
  ...d3Palettes,
  ...dalePalettes,
  ...ducciPalettes,
  ...duotonePalettes,
  ...expositoPalettes,
  ...feathersPalettes,
  ...flourishPalettes,
  ...golidmiscPalettes,
  ...hildaPalettes,
  ...iivonenPalettes,
  ...judsonPalettes,
  ...jungPalettes,
  ...kovecsesPalettes,
  ...lospecPalettes,
  ...mayoPalettes,
  ...metbrewerPalettes,
  ...momaPalettes,
  ...orbifoldPalettes,
  ...ranganathPalettes,
  ...rohlfsPalettes,
  ...roygbivsPalettes,
  ...spatialPalettes,
  ...systemPalettes,
  ...tsuchimochiPalettes,
  ...tundraPalettes,
];
